export default __webpack_public_path__ + "static/media/away.7d3d1e13.svg";